import classNames from 'classnames';
import MultiPicker from 'components/foundation/pickers/MultiPicker/MultiPicker';
import { useOpenable } from 'hooks';
import { first } from 'lodash';
import { ClassName } from 'types/ClassName';
import EquipmentAddOnDialog from '../EquipmentAddOnDialog/EquipmentAddOnDialog';
import EquipmentPicker from '../EquipmentPicker/EquipmentPicker';
import './EquipmentAddOnPicker.scss';

export interface IEquipmentAddOnPickerProps {
  className?: ClassName;
  ids: string[];
  filteredIds?: string[];
  placeholder?: string;
  onChange: (ids: string[]) => void;
}

const EquipmentAddOnPicker = (props: IEquipmentAddOnPickerProps) => {
  const { className, ids, filteredIds, placeholder, onChange } = props;

  const equipmentAddOnOpenable = useOpenable();

  const handleOnChange = (ids: string[]) => {
    if (ids.length > 1) {
      onChange(ids.filter((ids) => ids !== null));
    } else {
      onChange(ids);
    }
  };

  const handleAddOnDialogSubmit = (equipmentIds: string[]) => {
    equipmentAddOnOpenable.close();
    onChange(equipmentIds);
  };

  const idsWithFilter = filteredIds ? ids.filter((id) => !filteredIds.some((filteredId) => filteredId === id)) : ids;

  const classes = classNames('equipment-add-on-picker', className);

  const renderItem = (value: string | null, index: number) => {
    const onEquipmentSelect = (id: string | null) => {
      if (index === 0 || index < ids.length) {
        if (id !== null) {
          const newValues = [...ids];
          newValues[index] = id;
          handleOnChange(newValues);
        } else {
          handleOnChange(ids.filter((v, i) => i !== index));
        }
      }
    };
    return (
      <EquipmentPicker
        className={index !== 0 ? 'mt-4' : ''}
        filteredIds={filteredIds ? ids.concat(filteredIds) : ids}
        key={value ?? 'null'}
        value={value}
        onSelect={onEquipmentSelect}
        placeholder={placeholder}
        filterAddOns={false}
      />
    );
  };

  return (
    <div className={classes}>
      <EquipmentAddOnDialog
        isOpen={equipmentAddOnOpenable.isOpen}
        onClose={equipmentAddOnOpenable.close}
        onSubmit={handleAddOnDialogSubmit}
        currentSelections={idsWithFilter}
        selectedId={first(filteredIds)}
      />
      <MultiPicker
        onAddClick={equipmentAddOnOpenable.open}
        limit={20}
        renderItem={renderItem}
        values={idsWithFilter && idsWithFilter.length ? idsWithFilter : [null]}
        className={'add-on-multipicker'}
      />
    </div>
  );
};

export default EquipmentAddOnPicker;
